import React from "react";
import Styles from "./styles.module.scss";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";

import {setCapsuleQuestionnaireModalStatus} from "../../../store/cabinet/action";
import {isCapsuleLocked, isCapsuleSealed, pluralHandler} from "../../../helpers/capsule";

const CabinetCapsuleQuestionnaire = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const capsuleStats = useSelector(store => store.cabinet.capsuleStats);

    const questionnaire = capsuleStats?.stats?.questionnaire;
    const percent = Math.min(questionnaire?.percent || 0, 100);
    const isFull = percent >= 100;
    // пока капсула не куплена, раздел закрыт
    const isLocked = isCapsuleLocked(capsuleStats?.capsule_status);
    // запечатанную капсулу уже не дополняют: раздел открывается только на чтение
    const isSealed = isCapsuleSealed(capsuleStats?.capsule_status);

    const openHandler = () =>{
        if (isLocked || isSealed || !capsuleStats){
            return;
        }
        dispatch(setCapsuleQuestionnaireModalStatus(true));
    }

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetPC}`}>
                <div className={`${Styles.cardWrap} ${Styles.border3dOuterXl}`}>
                    <div className={`${Styles.cardHead}`}>
                        <div className={`${Styles.cardTitle}`}>{t('Анкета')}</div>
                        {isFull && !isLocked && !isSealed ? (
                            <div className={`${Styles.cardChip}`} onClick={openHandler}>{t('Посмотреть анкету')}</div>
                        ) : null}
                    </div>

                    <div className={`${Styles.cardNote}`}>
                        {t('Для формирования вашей модели личности пожалуйста заполните анкету')}
                    </div>

                    {/* у закрытой капсулы шкала пустая и с прочерками, и по макету
                        она есть только в широкой раскладке */}
                    <div className={`${Styles.progressWrap} ${isLocked ? Styles.progressWrapLocked : ''}`}>
                        <div className={`${Styles.progressBar}`}>
                            <div className={`${Styles.progressFill}`} style={{width: `${isLocked ? 0 : percent}%`}}/>
                        </div>
                        <div className={`${Styles.progressLabels}`}>
                            {isLocked ? (
                                <>
                                    <span className={`${Styles.progressLocked}`}>–</span>
                                    <span className={`${Styles.progressLocked}`}>–</span>
                                </>
                            ) : (
                                <>
                                    <span className={`${Styles.progressPercent}`}>{t('Заполнено на')} {percent}%</span>
                                    <span className={`${Styles.progressCount}`}>
                                        {questionnaire?.answered || 0} {t('из')} {questionnaire?.total || 0} {pluralHandler(questionnaire?.total, [t('вопроса'), t('вопросов'), t('вопросов')])}
                                    </span>
                                </>
                            )}
                        </div>
                    </div>

                    <div
                        className={`${Styles.cardBtn} ${isLocked || isSealed ? Styles.cardBtnDsb : ''}`}
                        onClick={openHandler}
                    >
                        {isSealed ? t('Запечатано') : (isFull && !isLocked ? t('Заполнено') : t('Заполнить'))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetCapsuleQuestionnaire;
